import {register} from '../modules/eventMap';

const init = (el) => {
    const form = el.closest('form');
    const hook = 'data-is-invalid-field-focussed';

    if (form && !form.getAttribute(hook)) {
        const invalidControls = [
            ...form.querySelectorAll('[aria-invalid="true"]')
        ];
        const firstInvalidControl = invalidControls[0];

        // Set a flag so it only runs once
        form.setAttribute(hook, 'true');

        firstInvalidControl.focus({focusVisible: true});
    }
};

const focusInvalidControl = () => {
    register('focusInvalidControl', {init});
};

export {focusInvalidControl};
